/**
 * Here to add and manage all the Font Awesome library inside the whole app
 * so it won't bother your main code
 */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEdit,
  faSyncAlt,
  faRedoAlt,
  faShareAlt,
  faMinusCircle,
  faPlusCircle,
  faPlus,
  faMinus,
  faClock,
  faTimes,
  faBookOpen,
  faUsers,
  faThumbsUp,
  faThumbsDown,
  faCheck,
} from "@fortawesome/pro-regular-svg-icons";

library.add(
  faEdit,
  faSyncAlt,
  faRedoAlt,
  faShareAlt,
  faMinusCircle,
  faPlusCircle,
  faPlus,
  faMinus,
  faClock,
  faTimes,
  faBookOpen,
  faUsers,
  faThumbsUp,
  faThumbsDown,
  faCheck,
);
